import React from 'react';
import '../App.css';

const TicketPage = () => {
  return (
    <div className="ticket-confirmation-screen">
      <div className="ticket-confirmation-card">

        <img src="/assets/Logo/Logo final.png" alt="Durden" className="ticket-confirm-logo" />

        <div className="ticket-confirm-check">✓</div>

        <h1 className="ticket-confirm-title">Ta place est sécurisée.</h1>

        <p className="ticket-confirm-subtitle">
          Patiente pour plus d'informations —<br />
          on t'annoncera tout en temps et en heure.
        </p>

        <p className="ticket-confirm-footer">
          Bienvenue au Festival Mic &amp; Cam.<br />
          <span>Alabasta Records.</span>
        </p>

      </div>
    </div>
  );
};

export default TicketPage;
